import type { IconProps } from "./types";

export function X({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8047 4.19531C12.0651 4.45565 12.0651 4.87773 11.8047 5.13807L8.94238 8L11.8047 10.8619C12.0651 11.1223 12.0651 11.5443 11.8047 11.8047C11.5443 12.0651 11.1223 12.0651 10.8619 11.8047L8 8.94238L5.13807 11.8047C4.87773 12.0651 4.45565 12.0651 4.19531 11.8047C3.93497 11.5443 3.93497 11.1223 4.19531 10.8619L7.05762 8L4.19531 5.13807C3.93497 4.87773 3.93497 4.45565 4.19531 4.19531C4.45565 3.93497 4.87773 3.93497 5.13807 4.19531L8 7.05762L10.8619 4.19531C11.1223 3.93497 11.5443 3.93497 11.8047 4.19531Z"
        fill={currentColor}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
}
